import React, {FC} from 'react';
import styled, {css} from 'styled-components';

/*
 * Style.
 */

interface StyledLoaderProps {
  $color: string;
}

export const StyledLoader = styled.div<StyledLoaderProps>`
  transform: translate(-50%, -50%);
  height: 26px;
  width: 26px;
  box-sizing: border-box;
  border-radius: 13px;
  ${(p) => setSpinnerGradientEndColor(p.$color)}
  animation: 1s rotate infinite linear;

  &:before {
    content: '';
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    height: 20px;
    width: 20px;
    background: #fff;
    border-radius: 48px;
  }
  &:after {
    content: '';
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    height: 3px;
    width: 3px;
    background: ${(p) => p.$color};
    border-radius: 3px;
  }

  @keyframes rotate {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

const setSpinnerGradientEndColor = (color: string) => css`
  background: conic-gradient(from 90deg at 50% 50%, rgba(0, 0, 0, 0) 0deg, ${color} 360deg);
`;

/*
 * Component.
 */

export interface LoaderProps {
  color: string;
}

export const Loader: FC<LoaderProps> = ({color}) => <StyledLoader $color={color} />;
